import { makeEntityScaffold } from '@classpass/saga-tools';
import URLS from 'constants/urls';

function handler({ httpClient }, data) {
  return httpClient.post(
    URLS.connect.credentials,
    {
      partner_id: data.partnerId,
      api_key: data.apiKey,
    },
    {
      ignoreUnauthorizedError: true,
    }
  );
}

export default makeEntityScaffold('SAGA.API.CONNECT', handler);
